import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Task } from '../../models/task';

@Component({
  selector: 'app-update-task-modal',
  templateUrl: './update-task-modal.component.html',
  styleUrls: ['./update-task-modal.component.css']
})
export class UpdateTaskModalComponent implements OnInit {
  finished = false;
  comments = '';

  constructor( public dialogRef: MatDialogRef<UpdateTaskModalComponent>,
  @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }

  onCloseConfirm() {
    const currentDate = new Date();
    this.data.task.comments = this.comments;
    this.data.task.finished = this.finished;
    this.data.task.updatedDate = currentDate.toISOString();
    this.data.task.updated = true;
    this.dialogRef.close(this.data);
  }

  onCloseCancel() {
    this.dialogRef.close('cancel');
  }

}



// WEBPACK FOOTER //
// ./src/app/tasks/update-task-modal/update-task-modal.component.ts